import { getLenis } from '../lib/lenis';
import { onScroll } from '../lib/scroll';

// Sticky header: frost it once the page moves, and drive the mobile panel.
// The panel is CSS-animated (grid-template-rows), JS only flips .is-open.
export function initNav(): void {
  const nav = document.querySelector<HTMLElement>('[data-nav]');
  if (!nav) return;

  onScroll(() => {
    nav.classList.toggle('is-scrolled', (window.scrollY || document.documentElement.scrollTop || 0) > 8);
  });

  const toggle = nav.querySelector<HTMLButtonElement>('[data-nav-toggle]');
  const panel = nav.querySelector<HTMLElement>('[data-nav-panel]');
  if (!toggle || !panel) return;

  const setOpen = (open: boolean): void => {
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // Freeze the page behind an open menu.
    if (open) getLenis()?.stop();
    else getLenis()?.start();
  };

  toggle.addEventListener('click', () => {
    setOpen(!nav.classList.contains('is-open'));
  });

  // Any choice inside the panel closes it.
  panel.addEventListener('click', (event) => {
    if ((event.target as HTMLElement).closest('a')) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });
}
